import { render } from "./WomenView.vue?vue&type=template&id=363c16f9"
import script from "./WomenView.vue?vue&type=script&lang=js"
export * from "./WomenView.vue?vue&type=script&lang=js"

import "./WomenView.vue?vue&type=style&index=0&id=363c16f9&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__